export default __webpack_public_path__ + "static/favicon-0b289f2bdcbf81b0a6df0118f50c4426.png";